import { Paragraph, Skeleton } from '@welbe/web-design-system';
import { Exams } from './components/Exams/Exams';
import { Lecture } from './components/Lecture/Lecture';
import { Sections } from './components/Sections/Sections';
import { Workshops } from './components/Workshops/Workshops';
import { useMoreInfo } from './MoreInfo.hooks';
import { Container, ContainerTables, EmptyContainer } from './MoreInfo.styles';

export type DefaultActivity = { rows?: any[] };

type MoreInfoProps = {
	employeeId: string;
};

export const MoreInfo = ({ employeeId }: MoreInfoProps) => {
	const { isLoading, isEmptyData, employeeActivity } = useMoreInfo({
		employeeId,
	});

	if (isLoading) {
		return (
			<Container>
				<Skeleton height="150px" width="100%" />
				<ContainerTables>
					<Skeleton height="150px" width="100%" />
					<Skeleton height="150px" width="100%" />
					<Skeleton height="150px" width="100%" />
				</ContainerTables>
			</Container>
		);
	}

	if (isEmptyData) {
		return (
			<EmptyContainer>
				<Paragraph fontWeight="600">No hay datos para mostrar</Paragraph>
			</EmptyContainer>
		);
	}

	return (
		<Container>
			<Exams rows={employeeActivity.exams} />
			<ContainerTables>
				<Lecture rows={employeeActivity.chats} />
				<Workshops rows={employeeActivity.workshops} />
				<Sections rows={employeeActivity.sessions} />
			</ContainerTables>
		</Container>
	);
};
